<template>
  <div>
    <page-header :title="$t('scope.text_295')" />
    <page-body>
      <invoice-address-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import InvoiceAddressManagerList from './components/List'

export default {
  name: 'invoiceAddressManagerIndex',
  components: {
    InvoiceAddressManagerList,
  },
  data () {
    return {
      listId: 'InvoiceAddressManagerList',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
